import type { AdminAgentContext } from '@mcn-platform/models';

/**
 * Derives agent routing context from the current location pathname (admin app routes under /app/...).
 */
export function pathnameToAdminAgentContext(pathname: string): AdminAgentContext {
  const route = pathname;
  const ctx: AdminAgentContext = { route };

  const courseMatch = pathname.match(/\/course-editor\/([^/]+)/);
  if (courseMatch && courseMatch[1] && courseMatch[1] !== 'new') {
    ctx.courseId = courseMatch[1];
  }

  const productMatch = pathname.match(/\/product-editor\/([^/]+)/);
  if (productMatch && productMatch[1] && productMatch[1] !== 'new') {
    ctx.productId = productMatch[1];
  }

  const programMatch = pathname.match(/\/program-editor\/([^/]+)/);
  if (programMatch && programMatch[1] && programMatch[1] !== 'new') {
    ctx.programId = programMatch[1];
  }

  return ctx;
}
